import { applyMiddleware, compose, PreloadedState } from 'redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore } from 'redux-persist';
import { registerStore } from 'spw-redux/store-registry';
import * as Sentry from '@sentry/react';
import { sentryEnhancerOptions } from 'spw-redux/utils';
import reducer, { RootState } from './reducer';
import { run as runSagas, sagaMiddleware } from './sagas';

// potential issue to watch out for: https://github.com/getsentry/sentry-javascript/issues/3148
const sentryReduxEnhancer = Sentry.createReduxEnhancer(sentryEnhancerOptions);

const dataTooLong = '<<DATA TOO LONG TO SERIALIZE>>';

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer,
    enhancers: [sentryReduxEnhancer, compose(applyMiddleware(sagaMiddleware))],
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
    devTools: {
      stateSanitizer: (state: any) => ({
        ...state,
        floorplanReducer: {
          ...state.floorplanReducer,
          floorplanGeoJson: dataTooLong,
          originalFileDataUrl: dataTooLong,
          currentFloorplan: {
            ...state.floorplanReducer.currentFloorplan,
            image: dataTooLong,
          },
        },
        calculatorReducer: {
          ...state.calculatorReducer,
          worksheets: state.calculatorReducer.worksheets.map((ws: any) => ({
            ...ws,
            rowsByCategory: '<<DATA OMITTED>>',
            rowsBySubcategory: '<<DATA OMITTED>>',
            breakDownRows: '<<DATA OMITTED>>',
            scenario: '<<DATA OMITTED>>',
            rows: '<<DATA OMITTED>>',
          })),
        },
      }),
    },
    preloadedState,
  });
};

const store = setupStore();

runSagas();
registerStore(store);

const persistor = persistStore(store);

export type AppStore = ReturnType<typeof setupStore>;

export { store, persistor };
